import PropTypes from "prop-types";
import { useCheckoutStore } from "../../store/useCheckoutStore";
import { useVizionarioStore } from "../../store/useVizionarioStore";

Locations.propTypes = {
  onClick: PropTypes.func,
  currentValue: PropTypes.object,
  locations: PropTypes.array,
};
export default function Locations(props) {
  const { onClick, currentValue, locations } = props;
  const numberFormat = new Intl.NumberFormat("es-CO");
  const { setSelectedSeats } = useCheckoutStore();
  const isVizionario = useVizionarioStore((state) => state.isVizionario);
  const isCineFan = useVizionarioStore((state) => state.isCineFan);

  const handleSelectLocation = (location, difference, isVizionario) => {
    onClick({ location: { ...location, difference, isVizionario } });
    setSelectedSeats([]);
  };

  const getButtonLocation = (location, otherLocation, isVizionario) => {
    let difference = otherLocation
      ? parseInt(otherLocation.valor) - parseInt(location.valor)
      : 0;
    difference = difference < 0 ? difference * -1 : difference;
    let differenceFormat = numberFormat.format(difference);
    let message = isVizionario
      ? `Ahorras <strong>$${differenceFormat}</strong> por boleta`
      : `Afiliate y ahorra <strong>$${differenceFormat}</strong> por boleta`;

    return (
      <button
        key={location.codigo}
        onClick={() => handleSelectLocation(location, difference, isVizionario)}
        className={
          currentValue && currentValue.codigo === location.codigo
            ? "selected"
            : ""
        }
      >
        <div className="showtimeDetail-location-info">
          Ubicación <strong>{location.zona}</strong>
          <div className="showtimeDetail-price">
            ${numberFormat.format(parseInt(location.valor))}
          </div>
        </div>
        {difference > 0 && (
          <div className="showtimeDetail-price-difference">
            <div
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
          </div>
        )}
      </button>
    );
  };

  const renderLocations = () => {
    let currentLocations = locations.filter((location) => location.valor > 1);
    let zoneLocations = [];

    return currentLocations.map((location) => {
      let isAvalLocation = location.descripcion.toLowerCase().includes("aval");
      let isVizionarioLocation =
        location.ClienteFrecuente.toLowerCase() === "habilitado";
      let zone = location.zona;

      if (zoneLocations.includes(zone)) {
        return null;
      }

      let generalLocation = locations.find(
        (location) =>
          location.zona === zone &&
          location.ClienteFrecuente.toLowerCase() === "deshabilitado"
      );
      let vizionarioLocation = locations.find(
        (location) =>
          location.zona === zone &&
          !location.descripcion.toLowerCase().includes("aval") &&
          location.ClienteFrecuente.toLowerCase() === "habilitado"
      );

      if (isVizionarioLocation && isAvalLocation && isVizionario && isCineFan) {
        zoneLocations.push(zone);
        return getButtonLocation(location, generalLocation, isVizionario);
      } else if (isVizionario && isVizionarioLocation && !isCineFan) {
        zoneLocations.push(zone);
        return getButtonLocation(location, generalLocation, isVizionario);
      } else if (!isVizionario && !isCineFan) {
        zoneLocations.push(zone);
        return getButtonLocation(location, vizionarioLocation, isVizionario);
      } else if (!vizionarioLocation) {
        return getButtonLocation(location, generalLocation, isVizionario);
      }
    });
  };

  return (
    <div className="showtimeDetail-pay-methods">
      <div className="showtimeDetail-label">Selecciona la ubicación:</div>
      <div className="showtimeDetail-menu">{renderLocations()}</div>
    </div>
  );
}
